import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Table } from "react-bootstrap";
import {
  Box,
  FeaturedBox,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import { CustomCheckbox } from "../../../../components/styled/FormElements";

const UserPermissions = ({ permissions, setPermissions, watch }) => {
  const { t } = useTranslation();
  const userType = watch("user_type_id");

  const [loading, setLoading] = useState(false);

  const [permissionTypes, setPermissionTypes] = useState([
    { id: 1, name: "users" },
    // { id: 2, name: "meetings" },
    { id: 2, name: "products" },
    { id: 3, name: "clients" },
    { id: 4, name: "quotations" },
    { id: 5, name: "sales_invoices" },
  ]);

  const [permissionOperations, setPermissionOperations] = useState([
    { id: 1, name: "create" },
    { id: 2, name: "edit" },
    { id: 3, name: "view" },
    { id: 4, name: "delete" },
  ]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    const numericValues = [1, 2, 3, 4];

    setPermissions((prevPermissions) => {
      const currentPermissions = prevPermissions[name] || [];
      let updatedPermissions;

      if (value === "all") {
        updatedPermissions = currentPermissions.includes("all")
          ? []
          : ["all", ...numericValues];
      } else {
        const val = parseInt(value);
        const toggled = currentPermissions.includes(val)
          ? currentPermissions.filter((item) => item !== val)
          : [...currentPermissions, val];

        const hasAllIndividual = numericValues.every((id) =>
          toggled.includes(id)
        );

        updatedPermissions = hasAllIndividual
          ? ["all", ...numericValues]
          : toggled.filter((item) => item !== "all");
      }

      return { ...prevPermissions, [name]: updatedPermissions };
    });
  };

  return (
    <Box className="overflow-x-auto">
      <StyledTable>
        {loading ? (
          <ThemeLoader />
        ) : (
          <>
            <thead>
              <tr>
                <th className="title-column">
                  <FeaturedBox
                    // display="block"
                    width="100%"
                    padding="10px 20px"
                    bg="var(--lightGrayBg)"
                    radius="12px"
                    size="16px"
                    color="var(--text)"
                    weight="600"
                    className="mt-3"
                  >
                    {t("features")}
                  </FeaturedBox>
                </th>
                <th className="title-column">
                  <FeaturedBox
                    // display="block"
                    width="100%"
                    padding="10px 20px"
                    bg="var(--lightGrayBg)"
                    radius="12px"
                    size="16px"
                    color="var(--text)"
                    weight="600"
                    className="mt-3"
                  >
                    {t("all")}
                  </FeaturedBox>
                </th>
                {permissionOperations?.map((operation, id) => (
                  <th className="title-column" key={id}>
                    <FeaturedBox
                      // display="block"
                      width="100%"
                      padding="10px 20px"
                      bg="var(--lightGrayBg)"
                      radius="12px"
                      size="16px"
                      color="var(--text)"
                      weight="600"
                      className="mt-3"
                    >
                      {t(operation.name)}
                    </FeaturedBox>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {permissionTypes?.map((type) => (
                <tr key={type.id}>
                  <td style={{ width: "160px" }}>
                    <FeaturedBox
                      // display="block"
                      width="100%"
                      // weight="bold"
                      padding="17px 20px"
                      bg="var(--lightGrayBg)"
                      radius="12px"
                      size="16px"
                      color="var(--text)"
                    >
                      {t(type.name)}
                    </FeaturedBox>
                  </td>
                  <td>
                    <FeaturedBox
                      width="100%"
                      padding="17px 20px"
                      bg={
                        permissions[type.id]?.includes("all")
                          ? "var(--lightGrayBg)"
                          : "transparent"
                      }
                      border={
                        !permissions[type.id]?.includes("all")
                          ? "1px solid var(--borderTwo)"
                          : "none"
                      }
                      radius="12px"
                      size="16px"
                      color="var(--text2)"
                      className="d-flex justify-content-center"
                    >
                      <CustomCheckbox
                        name={type.id.toString()}
                        checked={permissions[type.id]?.includes("all")}
                        value="all"
                        disabled={parseInt(userType) === 3}
                        onChange={handleChange}
                      />
                    </FeaturedBox>
                  </td>
                  {permissionOperations?.map((operation) => (
                    <td style={{ width: "160px" }} key={operation.id}>
                      <FeaturedBox
                        width="100%"
                        // weight="bold"
                        padding="17px 20px"
                        bg={
                          permissions[type.id]?.includes(operation.id)
                            ? "var(--lightGrayBg)"
                            : "transparent"
                        }
                        border={
                          !permissions[type.id]?.includes(operation.id)
                            ? "1px solid var(--borderTwo)"
                            : "none"
                        }
                        radius="12px"
                        size="16px"
                        color="var(--text2)"
                        className="d-flex justify-content-center"
                      >
                        <CustomCheckbox
                          name={type.id.toString()}
                          checked={permissions[type.id]?.includes(operation.id)}
                          value={operation.id}
                          // disabled={parseInt(userType) === 3}
                          onChange={handleChange}
                        />
                      </FeaturedBox>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </>
        )}
      </StyledTable>
    </Box>
  );
};

export default UserPermissions;

// Styled table to match your custom styling
export const StyledTable = styled(Table)`
  border-bottom: 1px solid var(--borderLight);
  margin-bottom: 0;
  table-layout: auto;
  thead tr {
    /* border-bottom: 1px solid var(--borderLight); */
  }
  th,
  td {
    text-align: center;
    vertical-align: middle;
    /* padding: 0 16px; */
    border: none;
  }

  th {
    font-size: 16px;
    font-weight: 500;
    color: var(--text);
  }

  td {
    font-size: 14px;
  }

  th.title-column {
    width: 160px;
  }
  th.title-column-two {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
